import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "512",
  height: "512",
  fill: "#276fff",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10 26h39.172l-3.586 3.586a2 2 0 1 0 2.828 2.828l7-7a2 2 0 0 0 0-2.828l-7-7a2 2 0 1 0-2.828 2.828L49.172 22H10a2 2 0 0 0 0 4M54 38H14.828l3.586-3.586a2 2 0 1 0-2.828-2.828l-7 7a2 2 0 0 0 0 2.828l7 7c.39.391.902.586 1.414.586s1.024-.195 1.414-.586a2 2 0 0 0 0-2.828L14.828 42H54a2 2 0 0 0 0-4" }, null, -1)
  ]))]))
}
export default { render: render }